import React from 'react';
import { Icon } from 'antd';

const optionsDefault = {
  okText: 'Готово',
  icon: <Icon type="check-circle" theme="filled" />,
  closable: false,
  maskClosable: true,
  centered: true,
  className: 'employee-success-form',
  onOk() {},
  onCancel() {},
};

export const successCreateTemplate = name => ({
  ...optionsDefault,
  title: 'Шаблон успешно сохранен!',
  content: `Шаблон предложения «${name}» успешно сохранен!`,
});

export const successUpdateTemplate = name => ({
  ...optionsDefault,
  title: 'Изменения успешно сохранены!',
  content: `Изменения успешно внесены в шаблон «${name}».`,
});

export const successDeleteTemplate = id => ({
  ...optionsDefault,
  title: 'Шаблон успешно удален!',
  content: `Шаблон ${id} успешно удален!`,
});

export const successDeleteSelectedTemplates = count => ({
  ...optionsDefault,
  title: 'Выбранные шаблоны успешно удалены!',
  content: `Шаблоны успешно удалены!`,
});
